/**
 * @description API configuration for Lynx Admin portal
 *
 * @notes
 * - Points to the same backend API as the merchant frontend
 * - Default port 5001 for local development
 * - REACT_APP_API_URL overrides for production (api.lynx.build/api)
 */

const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  TIMEOUT: 10000,
};

export default config;
